export enum OrderStateEnum {
    ABANDONED = "ABANDONED",
    CANCELLED = "CANCELLED",
    COMMITTED = "COMMITTED",
    COMPLETED = "COMPLETED",
    DECLINED = "DECLINED",
    FINALIZED = "FINALIZED",
    INITIALIZED = "INITIALIZED",
    INTERNAL_MANUAL_ATTENTION_REQUIRED = "INTERNAL_MANUAL_ATTENTION_REQUIRED",
    MANUAL_ATTENTION_REQUIRED_BY_DEALER = "MANUAL_ATTENTION_REQUIRED_BY_DEALER",
    READY_TO_AUTHENTICATE = "READY_TO_AUTHENTICATE",
    READY_TO_COMMIT = "READY_TO_COMMIT",
    RESERVED = "RESERVED",
    SUBMITTED = "SUBMITTED",
}

export enum SignatureMethodEnum {
    BANK_ID = "BANK_ID",
    ID_PHOTO = "ID_PHOTO",
    MANUAL_SIGN = "MANUAL_SIGN",
    REMOTE_BANK_ID = "REMOTE_BANK_ID",
    REMOTE_ONE_TIME_PIN_AND_BANK_ID = "REMOTE_ONE_TIME_PIN_AND_BANK_ID",
    SIGN_ONLY = "SIGN_ONLY",
}
